module.exports = __webpack_public_path__ + "static/media/moons-white.3707571a.svg";